import { ObjectBooleanTimeline } from "../../../features/Charts/ObjectBooleanTimeline";
import { getTimeRangeFromTimespan } from "../../../utils/timeUtils";
import { themedUseStyletron } from "../../../theme/customTheme";
import { StyledDivider } from "baseui/divider";
import { ParagraphMedium } from "baseui/typography";
import { FormattedMessage } from "react-intl";


const InsightsPanel = (props: any) => {
    const [css, theme] = themedUseStyletron()

    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);

    return (<>
        <ParagraphMedium><FormattedMessage id="PlantInsightsPanel.operatinghours" defaultMessage="Operating Hours" /></ParagraphMedium>
        <ObjectBooleanTimeline currentValue={props.isOn} onColor={theme.appColors.aggregate.on} showStatistics offColor={theme.colors.backgroundTertiary} start={timeRange.start} end={timeRange.end} objectId={props.id} resourceGroupId={props.resourceGroupId} propertyName={'isOn'}></ObjectBooleanTimeline>
        <div className={css({ width: '100%' })}><StyledDivider $size='cell'></StyledDivider></div>
    </>)
}

export default InsightsPanel